import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function query(data) {
  return request({
    url: URL.mdm.ruleConfig.queryUrl,
    method: 'post',
    data
  })
}

// 获取详情
export function detail(data) {
  return request({
    url: URL.mdm.ruleConfig.detailUrl,
    method: 'post',
    data
  })
}

// 保存
export function save(data) {
  return request({
    url: URL.mdm.ruleConfig.saveUrl,
    method: 'post',
    data
  })
}

// 启用/停用
export function setEnabled(data) {
  return request({
    url: URL.mdm.ruleConfig.setEnabledUrl,
    method: 'post',
    data
  })
}

// 复制
export function copy(data) {
  return request({
    url: URL.mdm.ruleConfig.copyUrl,
    method: 'post',
    data
  })
}

// 获取规则条件列表
export function queryConditions(data) {
  return request({
    url: URL.mdm.ruleConfig.queryConditionsUrl,
    method: 'post',
    data
  })
}
